<template>
  <section class="company-intro">
    <div class="container">
      <div class="intro-content">
        <div class="intro-logo">
          <img src="https://onbotics-map.oss-cn-shanghai.aliyuncs.com/swc.png" alt="Company Logo" />
        </div>
        <div class="intro-text">
          <h2 class="gradient-text">About SIWEECI</h2>
          <p class="intro-vision">Committed to improving the quality of life for people with disabilities through
            innovative technology</p>
          <p class="intro-desc">
            SIWEECI Health Technology (shanghai) Co., Ltd. was foundedin 2014, has been operating electric wheelchairs
            and scootersfor
            over 10 years. As a company, we deeply understand thatcustomer trust is the foundation of our
            long-termdevelopment.In the
            past decade, we have rapidly grown intoa well-known mid to high end brand. Excellent and reliablequality and
            supporting after-
            sales service helps us earn agood reputation in the industry.
            With the development of the domestic rehabilitationequipment market, the company successively
            establishedSIWEECl
            Rehabilitation Equipment (Jiangsu) Co. Ltd onJanuary 1,2020, and FALNKEEF(Suzhou) Health TechnologyCo., Ltd
            in
            2023,focusing on product research anddevelopment,export and Al intelligent internet
            electricwheelchair,ultra-light carbon fibre
            wheelchair、decompression rehabilitation wheelchair and lightweightportable scooter.Siweeci has compliant
            factories in
            Changzhou, Zhejiang,Guangzhou, Suzhou and other production bases in China.Carrying excellent R&D and
            manufacturing of
            Siweeciproducts! At the meantime, Siweeci has been progressivelyexpandingits foreign trade export business,
            customers
            fromUnited States, Britain, Türkiye, Spain, Dubai and othercountries, and we have maintained good
            long-termcooperative
            relations.Nowadays,the company's product range has expanded toinclude medical equipment related products
            such as
            manualwheelchairs,electric wheelchairs, scooters, climbingmachines and oxygen concentrators. Our research
            anddevelopment
            centre located in Suzhou, Siweeci Companywelcomes your arrival, where you can always find a productthat
            suits you!
          </p>
          <ul class="intro-honor">
            <li>✔ National High-Tech Enterprise</li>
            <li>✔ ISO9001 Quality Management System Certification</li>
            <li>✔ Multiple Wheelchair Product Patents</li>
            <li>✔ Service Network Covers Nationwide</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CompanyIntro'
}
</script>

<style scoped>
.company-intro {
  background: #f6f8fa;
  padding: 5rem 2rem 4rem;
}

.container {
  max-width: 1100px;
  margin: 0 auto;
}

.intro-content {
  display: flex;
  align-items: center;
  gap: 3rem;
  flex-wrap: wrap;
}

.intro-logo img {
  width: 300px;
  height: 120px;
  border-radius: 24px;
  box-shadow: 0 4px 24px rgba(44, 90, 160, 0.08);
  background: #fff;
}

.intro-text {
  flex: 1;
  min-width: 260px;
}

.intro-text h2 {
  font-size: 2.2rem;
  margin-bottom: 1rem;
  font-weight: 700;
}

.intro-vision {
  font-size: 1.2rem;
  color: #2c5aa0;
  margin-bottom: 1.2rem;
  font-weight: 500;
}

.intro-desc {
  color: #555;
  font-size: 1.08rem;
  margin-bottom: 1.2rem;
  line-height: 1.7;
}

.intro-honor {
  list-style: none;
  padding: 0;
  color: #4a7bc8;
  font-size: 1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.intro-honor li {
  background: #e3f2fd;
  border-radius: 16px;
  padding: 0.5rem 1.2rem;
  margin-bottom: 0.5rem;
}

.gradient-text {
  background: linear-gradient(45deg, #2c5aa0, #4a7bc8);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

@media (max-width: 900px) {
  .intro-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 2rem;
  }

  .intro-logo img {
    margin-bottom: 1rem;
  }
}
</style>